import * as constants from '../constants/ActionTypes';
import Page from '../../lib/page';

const initialState = {
  locale: Page.getLocale(),
  islogin: Page.isLoggedIn(),
  islocaleChanged: false,
};

export default function (state = initialState, action) {
  switch (action.type) {
    case constants.LOCALE_CHANGED :
      return Object.assign({}, state, { locale: action.payload.nextLocale, islocaleChanged: true });
    case constants.LOGOUT :
      return Object.assign({}, state, { islogin: false });
    case constants.LOGIN :
      return Object.assign({}, state, { islogin: true });
    default :
      return state;
  }
}
